<template>
  <div>
    <el-dialog
      class="yhg-toast-dialog"
      :visible.sync="visible"
      :show-close="false"
      :center="true"
      :width="html ? '400px' : '320px'">
      <div v-if="html" v-html="html" class="text-center">
      </div>
      <div v-else class="toast-wrap">
        <i :class="['el-icon-' + type, 'color_' + type]"></i>
        <span class="_text">{{ content }}</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MsgBox',
  data () {
    return {
      content: '',
      type: 'info', // 'success','warning','error',
      html: null,
      time: 3000,
      visible: false
    }
  },
  mounted () {
    this.close();
  },
  methods: {
    close () {
      setTimeout(() => {
        this.visible = false
      }, this.time)
    }
  }
}
</script>

<style lang="scss">
.yhg-toast-dialog {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 15px;
  }
  .toast-wrap {
    display: flex;
    font-size: 16px;
    line-height: 1.5;
    i {
      display: inline-block;
      min-width: 24px;
      margin-right: 10px;;
      font-size: 24px;
    }
  }
}
</style>